import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  monitorLength: 0,
  monitor: [],
  encuestaMensual: []
}

export default function monitorReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_MONITOR:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_MONITOR:
      return {...state, saveLoader: action.payload}
    case actions.GET_MONITOR:
      return {...state, monitor: action.payload.monitor, encuestaMensual: action.payload.encuestaMensual, monitorLength: action.payload.monitorLength}
    default:
      return {...state};
  }
}